var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { Orders } from './order-fake-data';
var DataSourceService = (function () {
    function DataSourceService() {
        this.orders = Orders;
    }
    DataSourceService.prototype.getOrders = function (clientEmail) {
        return this.orders;
    };
    DataSourceService.prototype.getOrderbyId = function (id) {
        return this.orders.find(function (order) { return order.id == id; });
    };
    DataSourceService = __decorate([
        Injectable()
    ], DataSourceService);
    return DataSourceService;
}());
export { DataSourceService };
//# sourceMappingURL=datasource.service.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/DB/datasource.service.js
// module id = 809
// module chunks = 0